export enum EmailTypeEnum {
    Personal = "P",
    Business = "W"
}